import type { CurrentRead } from '@signalvote/data';
import type { DashboardAttentionDto } from '@signalvote/shared';
import { apiJson } from './apiFetch';
import { financeReadKeys } from '../../lib/queryKeys';
import { campaignHeaders, defineQuery } from '../../lib/data';

export type { DashboardAttentionDto };

const useDashboardAttentionRead = defineQuery({
  key: financeReadKeys.dashboardAttention,
  reads: 'GET /api/finance/dashboard/attention',
  fetch: (_params: undefined, { signal, campaignId }) =>
    apiJson<DashboardAttentionDto>('/api/finance/dashboard/attention', {
      signal,
      headers: campaignHeaders(campaignId),
      error: 'Failed to fetch dashboard attention items',
    }),
  staleTime: 30_000,
});

/**
 * The dashboard "Attention required" filing blockers (ADR-017): v1 = two
 * categories — over-limit contributions and incomplete-donor-info contributions.
 * Campaign-wide (no period params). The incomplete itemized-expenditure-payee
 * category is deferred to a fast-follow.
 */
export function useDashboardAttention(): CurrentRead<DashboardAttentionDto> {
  return useDashboardAttentionRead(undefined);
}
